export default (messageId) => {
    app.navigate(`inbox/${messageId}`, true);
};
